export default {
  vnc: {
    connecting: "Поврзување…",
    disconnect: "Исклучи",
    fullscreen: "Цел екран",
    exitFullscreen: "Излез од цел екран",
    status: {
      label: "Статус",
      connecting: "Поврзување…",
      connected: "Поврзан",
      disconnected: "Исклучен",
      error: "Грешка при поврзување",
    },
    errors: {
      connectionFailed: "Неуспешно поврзување со конзолата на уредот.",
    },
  },
  actions: {
    console: "Конзола",
  },
};
